import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ILeverageTokenInfoSummaryViewModel } from "./leverage-token-info-summary.interface";

@Component({
	selector: "leverage-token-info-summary",
	templateUrl: "./leverage-token-info-summary.component.html",
	styleUrls: ["./leverage-token-info-summary.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class LeverageTokenInfoSummaryComponent {
	@Input() vm: ILeverageTokenInfoSummaryViewModel = null;
	@Input() offerAmount: string;
	@Input() currentBorrow: string;
	@Input() futurePosition: string;
	@Input() isBuy: boolean;
	// TODO: CFD CLEANUP, remove ff
	@Input() cfdEnabled: boolean = false;
}
